/**
 * UTM Tracking
 * Captures utm_* params (+ friend_code) from the URL, persists them in a cookie,
 * and syncs the merged cookie value to the cart as line-item-free cart attributes
 * via the Storefront AJAX Cart API (/cart/update.js).
 */

var TT_UTM_COOKIE_NAME = 'utm_tracking_data';
var TT_UTM_COOKIE_DAYS = 30;
var TT_UTM_PARAM_KEYS = ['utm_campaign', 'utm_source', 'utm_medium', 'utm_content', 'utm_term', 'friend_code'];

/**
 * Cookie utilities — plain JS get/set/delete, no external libraries.
 */
var TTCookie = (function () {
  function set(name, value, days) {
    var expires = '';
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = '; expires=' + date.toUTCString();
    }
    document.cookie = name + '=' + encodeURIComponent(value) + expires + '; path=/; SameSite=Lax';
  }

  function get(name) {
    var nameEQ = name + '=';
    var parts = document.cookie.split(';');
    for (var i = 0; i < parts.length; i++) {
      var part = parts[i];
      while (part.charAt(0) === ' ') {
        part = part.substring(1, part.length);
      }
      if (part.indexOf(nameEQ) === 0) {
        return decodeURIComponent(part.substring(nameEQ.length, part.length));
      }
    }
    return null;
  }

  function remove(name) {
    document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; SameSite=Lax';
  }

  return { set: set, get: get, remove: remove };
})();

/**
 * Reads utm_* / friend_code params from the current URL's query string.
 * Returns null if none of the tracked params are present.
 */
function ttGetUrlUtmParams() {
  var params;
  try {
    params = new URLSearchParams(window.location.search);
  } catch (err) {
    return null;
  }

  var found = null;
  for (var i = 0; i < TT_UTM_PARAM_KEYS.length; i++) {
    var key = TT_UTM_PARAM_KEYS[i];
    if (params.has(key)) {
      found = found || {};
      found[key] = params.get(key);
    }
  }
  return found;
}

/**
 * Reads and JSON-parses the existing utm_tracking_data cookie.
 * Returns {} if the cookie is missing, empty, or not valid JSON.
 */
function ttReadUtmCookie() {
  var raw = TTCookie.get(TT_UTM_COOKIE_NAME);
  if (!raw) return {};
  try {
    var parsed = JSON.parse(raw);
    return (parsed && typeof parsed === 'object') ? parsed : {};
  } catch (err) {
    console.error('[utm-tracking] failed to parse existing cookie, resetting', err);
    return {};
  }
}

/**
 * Merges any UTM params found in the URL into the existing cookie value
 * (new values win on matching keys, unmatched old keys are preserved),
 * then writes the merged object back to the cookie with a refreshed 30-day expiry.
 * Returns the merged object (existing or newly merged) so callers can sync it to the cart.
 */
function ttCaptureAndMergeUtmData() {
  var existing = ttReadUtmCookie();
  var fromUrl = ttGetUrlUtmParams();

  if (!fromUrl) {
    return existing;
  }

  var merged = Object.assign({}, existing, fromUrl);

  try {
    TTCookie.set(TT_UTM_COOKIE_NAME, JSON.stringify(merged), TT_UTM_COOKIE_DAYS);
    console.log('[utm-tracking] cookie updated', merged);
  } catch (err) {
    console.error('[utm-tracking] failed to write cookie', err);
  }

  return merged;
}

/**
 * Pushes the merged cookie object to the cart as cart attributes.
 * /cart/update.js REPLACES attributes rather than merging, so this always
 * sends the full object read from the cookie, never a partial update.
 */
function ttSyncCartAttributes() {
  var data = ttReadUtmCookie();

  if (!data || Object.keys(data).length === 0) {
    return;
  }

  fetch('/cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ attributes: data })
  })
    .then(function (response) {
      if (!response.ok) {
        throw new Error('cart/update.js responded with ' + response.status);
      }
      return response.json();
    })
    .then(function () {
      console.log('[utm-tracking] cart attributes synced', data);
    })
    .catch(function (err) {
      console.error('[utm-tracking] cart attribute sync failed', err);
    });
}

/**
 * GoKwik's checkout runs in a cross-origin iframe/overlay, so Shopify's
 * checkout_completed pixel (which executes inside that cross-origin context)
 * can never reach the utm_tracking_data cookie set on this domain.
 * As a same-origin fallback: when the GoKwik modal closes, check /cart.js —
 * an empty cart means the order went through, so it's safe to clear the cookie.
 */
function ttHandleGokwikModalClosed() {
  fetch('/cart.js')
    .then(function (response) { return response.json(); })
    .then(function (cart) {
      if (cart && cart.item_count === 0) {
        TTCookie.remove(TT_UTM_COOKIE_NAME);
        console.log('[utm-tracking] cart empty after GoKwik checkout closed — order assumed placed, cookie cleared');
      }
    })
    .catch(function (err) {
      console.error('[utm-tracking] post-checkout cart check failed', err);
    });
}

(function () {
  ttCaptureAndMergeUtmData();

  // Safety net: re-sync whenever the cart page itself loads.
  if (window.location.pathname.indexOf('/cart') === 0) {
    ttSyncCartAttributes();
  }

  // Sync after any add-to-cart form submit, once the cart has had time to update.
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[action^="/cart/add"]');
    if (!form) return;

    setTimeout(function () {
      ttSyncCartAttributes();
    }, 800);
  });

  // Same-origin fallback for order completion (see ttHandleGokwikModalClosed above).
  window.addEventListener('gokwikLoaded', function () {
    try {
      gokwikSdk.on('modal_closed', function () {
        setTimeout(ttHandleGokwikModalClosed, 600);
      });
    } catch (err) {}
  });
})();
